export class HTTPError extends Error {
  constructor(method: string, endpoint: string) {
    const message = `HTTPError ${method} ${endpoint}`;

    super(message);

    this.name = message;
  }
}
